var TilesLoader = require('../../geo/ui/tiles-loader');

var LoaderOverlay = function (data) {
  var view = new TilesLoader();

  return view.render();
};

module.exports = LoaderOverlay;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/vis/overlays/loader.js
// module id = 1705
// module chunks = 6